import { getDocumentComposition } from './documentCompositions';
import { documentThemeToCssText } from './documentTheme';

const escapeHtml = (value = '') => String(value)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#039;');

/**
 * Enveloppe HTML commune pour les exports historiques qui ne sont pas encore
 * rendus via DocumentTemplate. Elle centralise la composition et les tokens
 * documentaires sans imposer de nouvelle mise en page au document métier.
 */
export const buildHtmlDocumentShell = ({
  title = 'Document',
  composition,
  styles = '',
  body = '',
  lang = 'fr',
  head = '',
}) => {
  const preset = getDocumentComposition(composition);
  const themeVariables = documentThemeToCssText();

  return `<!doctype html>
<html lang="${escapeHtml(lang)}" data-document-composition="${escapeHtml(preset.id)}">
<head>
  <meta charset="utf-8" />
  <meta name="document-composition" content="${escapeHtml(preset.id)}" />
  <title>${escapeHtml(title)}</title>
  ${head || ''}
  <style>
    :root { ${themeVariables}; }
    ${styles || ''}
  </style>
</head>
<body data-document-composition="${escapeHtml(preset.id)}">
${body || ''}
</body>
</html>`;
};
